import { Injectable } from '@angular/core';
import {UserService,BankPayload} from "../services/user.service";
import { Observable } from 'rxjs/Observable';
import {NotificationsService} from "angular2-notifications";

@Injectable()
export class BankService {

  constructor(private userService : UserService,private notif: NotificationsService) { }

    public getdepositlists(perpage,page,searchoption,expvalue):Observable<any> {    
        return this.userService.userequest('get','admdepositlists',null,{perpage:perpage,page:page,search:searchoption.search
            ,from:searchoption.time,to:searchoption.time1,export:expvalue});
    }
    public getfiatdepositlists(perpage,page,searchoption,expvalue):Observable<any> {
        return this.userService.userequest('get','admfiatdepositlists',null,{perpage:perpage,page:page,search:searchoption.search
            ,from:searchoption.time,to:searchoption.time1,export:expvalue});
    }

    /*
        api call for fetch withdraw request from customers
     */
    public getWithdrawList(perpage,page,searchoption,expvalue):Observable<any> {
        return this.userService.userequest('get','admwithdrawlist',null,{perpage:perpage,page:page,search:searchoption.search
                                                                                ,from:searchoption.time,to:searchoption.time1,expvalue:expvalue});
    }
    public getfiatWithdrawList(perpage,page,searchoption,expvalue):Observable<any> {        
        return this.userService.userequest('get','getfiatWithdrawList',null,{perpage:perpage,page:page,search:searchoption.search
            ,from:searchoption.time,to:searchoption.time1,expvalue:expvalue});
    }

    public withdraw_process(data):Observable<any> {
     return this.userService.userequest('post','withdraw_process',data);
    }
    public exchange_withdrawal(data):Observable<any> {
        return this.userService.userequest('post','exchange_withdrawal',data);
    }
    public updateCompleteDeposit(data):Observable<any> {
        return this.userService.userequest('post','complete-deposit',data);
    }
    public updateCancelDeposit(data):Observable<any> {
        return this.userService.userequest('post','cancel-deposit',data);
    }
    public crypto_scheduled_withdraw(data):Observable<any> {
        return this.userService.userequest('post','crypto_scheduled_withdraw',data);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/bank.service.ts